import { LOGO_URL } from "@/api";
import { LotusMark } from "@/components/Reveal";

const Emblem = () => (
  <div className="relative w-[300px] h-[300px] sm:w-[420px] sm:h-[420px] lg:w-[520px] lg:h-[520px]">
    <div className="absolute inset-0 rounded-full border border-gold/40" />
    <div className="absolute inset-3 rounded-full border border-gold/25" />
    <div className="absolute inset-8 rounded-full overflow-hidden shadow-[0_40px_80px_rgba(74,18,26,0.25)]">
      <img src={LOGO_URL} alt="Vaiyra — Rooted in Grace emblem" className="w-full h-full object-cover scale-110" />
    </div>
    <div className="absolute -bottom-2 -left-3 sm:-bottom-4 sm:-left-6">
      <div className="bg-ivory-card border border-gold/40 rounded-full p-3 sm:p-4 shadow-lg">
        <LotusMark className="w-6 h-6 sm:w-8 sm:h-8 text-gold-dark" />
      </div>
    </div>
    <div className="absolute top-3 -right-2 sm:top-6 sm:-right-4">
      <div className="bg-maroon text-ivory-card px-3 py-2 sm:px-5 sm:py-3 shadow-xl">
        <p className="text-[7px] sm:text-[9px] tracking-[0.35em] sm:tracking-[0.4em] uppercase text-gold-light">The Debut</p>
        <p className="font-display italic text-sm sm:text-lg leading-tight">Collection One</p>
      </div>
    </div>
  </div>
);

export default Emblem;
